import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import { useNavigate } from 'react-router';
import { StatusFilter, type FiltersProps } from './interfaces';
import { useNotification } from '@/context/notification';
import { useUser } from '@/data/user';
import { Permissions } from '@/models/user';

export const Filters = ({
  companies,
  selectedCompany,
  setSelectedCompany,
  localSearchTerm,
  setLocalSearchTerm,
  handleSearch,
  loading,
  statusValue,
  onStatusChange,
}: FiltersProps) => {
  const navigate = useNavigate();
  const { user } = useUser();
  const isAdmin = user?.permissoes.some(
    (permission) => permission.nome === Permissions.Admin
  );
  const { toast } = useNotification();

  const handleAddEmployee = () => {
    let companyId: string | undefined = selectedCompany?.id;

    if (!selectedCompany && isAdmin) {
      toast({
        content: 'Selecione uma empresa para adicionar um colaborador.',
        type: 'error',
      });
      return;
    }

    if (!isAdmin && !selectedCompany) {
      companyId = user?.colaborador?.empresa?.id?.toString();
    }

    navigate(`/empresa/gestao-de-colaboradores/registrar/${companyId}`);
  };

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        alignItems="end"
        justifyContent="space-between"
        mb={3}
      >
        <Box flex={1}>
          {isAdmin && (
            <Autocomplete
              fullWidth
              options={companies || []}
              value={selectedCompany}
              sx={{ flex: 1, maxWidth: { md: '80%' } }}
              onChange={(_, value) => setSelectedCompany(value)}
              getOptionLabel={(option) => option.empresa}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.empresa} (ID: {option.id}) -{' '}
                  {option?.CompanyPlans?.[0]?.Plan?.name}
                </li>
              )}
              renderInput={(params) => (
                <>
                  <FormLabel>Selecione a empresa abaixo</FormLabel>
                  <TextField {...params} placeholder="Escolha uma empresa" />
                </>
              )}
            />
          )}
        </Box>
        <Button
          startIcon={<AddIcon />}
          variant="contained"
          onClick={handleAddEmployee}
        >
          Adicionar colaborador
        </Button>
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        flexWrap="wrap"
        mb={3}
        gap={2}
      >
        <Stack
          direction="row"
          alignItems="center"
          maxWidth={{ md: 600 }}
          gap={2}
          flex={1}
        >
          <TextField
            placeholder="Pesquise por nome, email ou CPF"
            onChange={(e) => setLocalSearchTerm(e.target.value)}
            value={localSearchTerm}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            aria-label="Buscar colaborador"
            slotProps={{
              input: {
                endAdornment: <SearchIcon fontSize="small" sx={{ mr: 1 }} />,
              },
            }}
            sx={{ minWidth: { md: 300, xs: 200 }, flex: 1 }}
          />
          <Button variant="contained" onClick={handleSearch} disabled={loading}>
            Pesquisar
          </Button>
        </Stack>
        <FormControl>
          <InputLabel id="select-status-label">Status</InputLabel>
          <Select
            labelId="select-status-label"
            id="select-status"
            label="Status"
            value={statusValue}
            onChange={(event) => onStatusChange(event.target.value)}
          >
            <MenuItem value={StatusFilter.All}>Todos</MenuItem>
            <MenuItem value={StatusFilter.Registered}>Cadastrados</MenuItem>
            <MenuItem value={StatusFilter.Deleted}>Excluídos</MenuItem>
          </Select>
        </FormControl>
      </Stack>
    </>
  );
};
